import { ApplicationRef, Injectable, isDevMode } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SwUpdate } from "@angular/service-worker";
import { concat, first, from, interval, Subscription, switchMap } from "rxjs";
import { ServiceWorkerComponent } from "./service-worker.component";

@Injectable({ providedIn: "root" })
export class ServiceWorkerService {
    private CHECK_INTERVAL_MS = 6 * 60 * 60;
    private checkSub$: Subscription;

    constructor(
        private appRef: ApplicationRef,
        private updates: SwUpdate,
        private snackbar: MatSnackBar
    ) {}

    public listen(): void {
        if (isDevMode()) {
            return;
        }

        // Allow the app to stabilize first, before starting
        // polling for updates with `interval()`.
        const appIsStable$ = this.appRef.isStable.pipe(first(isStable => isStable));
        const everySixHours$ = interval(this.CHECK_INTERVAL_MS);
        const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everySixHours$);

        this.checkSub$ = everySixHoursOnceAppIsStable$
            .pipe(switchMap(() => from(this.updates.checkForUpdate())))
            .subscribe(newUpdate => {
                if (newUpdate) {
                    this.showSnackbar();
                }
            });
    }

    public close(): void {
        this.checkSub$?.unsubscribe();
    }

    private showSnackbar(): void {
        this.snackbar.openFromComponent(ServiceWorkerComponent, {
            panelClass: ["update-available"],
            verticalPosition: "bottom",
            horizontalPosition: "left",
            duration: 10000
        });
    }
}
